export const religions = [
  'Hindu', 'Muslim', 'Christian', 'Sikh', 'Buddhist', 'Jain', 'Parsi', 'Jewish', 'Other'
];

export const castes = {
  Hindu: ['Brahmin', 'Kshatriya', 'Vaishya', 'Nair', 'Nadar', 'Pillai', 'Menon', 'Iyer', 'Iyengar', 'Gounder', 'Mudaliar', 'Naidu', 'Reddy', 'Chettiar', 'Thevar', 'Maravar', 'Ezhava', 'Thiyya', 'Vishwakarma', 'Scheduled Caste', 'Scheduled Tribe', 'Other'],
  Muslim: ['Sunni', 'Shia', 'Ahmadiyya', 'Sufi', 'Other'],
  Christian: ['Roman Catholic', 'Syrian Catholic', 'Marthoma', 'CSI', 'Pentecostal', 'Latin Catholic', 'Jacobite', 'Orthodox', 'Other'],
  Sikh: ['Jat', 'Khatri', 'Arora', 'Ramgarhia', 'Saini', 'Other'],
  Buddhist: ['Mahayana', 'Theravada', 'Neo-Buddhist', 'Other'],
  Jain: ['Digambar', 'Shwetambar', 'Other'],
  Parsi: ['Parsi'],
  Jewish: ['Jewish'],
  Other: ['Other'],
};

export const stars = [
  'Ashwini', 'Bharani', 'Karthigai', 'Rohini', 'Mrigashirsham',
  'Thiruvathira', 'Punarvasu', 'Poosam', 'Ayilyam', 'Makam',
  'Pooram', 'Uthiram', 'Hastham', 'Chithirai', 'Swathi',
  'Vishakam', 'Anusham', 'Kettai', 'Moolam', 'Pooradam',
  'Uthiradam', 'Thiruvonam', 'Avittam', 'Sathayam', 'Poorattathi',
  'Uthirattathi', 'Revathi'
];

export const raasis = [
  'Mesham (Aries)', 'Rishabam (Taurus)', 'Midhunam (Gemini)',
  'Kadagam (Cancer)', 'Simham (Leo)', 'Kanni (Virgo)',
  'Thulam (Libra)', 'Viruchigam (Scorpio)', 'Dhanusu (Sagittarius)',
  'Makaram (Capricorn)', 'Kumbam (Aquarius)', 'Meenam (Pisces)'
];

export const motherTongues = [
  'Tamil', 'Malayalam', 'Telugu', 'Kannada', 'Hindi', 'Bengali',
  'Marathi', 'Gujarati', 'Punjabi', 'Odia', 'Urdu', 'Konkani',
  'Tulu', 'English', 'Other'
];

export const countries = [
  'India', 'United States', 'United Kingdom', 'Canada', 'Australia',
  'UAE', 'Saudi Arabia', 'Qatar', 'Kuwait', 'Oman', 'Bahrain',
  'Singapore', 'Malaysia', 'Germany', 'Other'
];

export const indianStates = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Puducherry', 'Chandigarh', 'Lakshadweep'
];

export const occupationCategories = [
  { value: 'private_sector', label: 'Private Sector' },
  { value: 'government', label: 'Government' },
  { value: 'business', label: 'Business' },
  { value: 'self_employed', label: 'Self Employed' },
  { value: 'not_working', label: 'Not Working' },
];

export const familyTypes = [
  { value: 'nuclear', label: 'Nuclear' },
  { value: 'joint', label: 'Joint' },
];

export const familyStatuses = [
  { value: 'middle_class', label: 'Middle Class' },
  { value: 'upper_middle_class', label: 'Upper Middle Class' },
  { value: 'rich', label: 'Rich' },
  { value: 'affluent', label: 'Affluent' },
];

export const familyValues = [
  { value: 'traditional', label: 'Traditional' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'liberal', label: 'Liberal' },
];

export const annualIncomeRanges = [
  { value: 'below_1_lakh', label: 'Below 1 Lakh' },
  { value: '1_to_2_lakh', label: '1 - 2 Lakhs' },
  { value: '2_to_3_lakh', label: '2 - 3 Lakhs' },
  { value: '3_to_5_lakh', label: '3 - 5 Lakhs' },
  { value: '5_to_7_lakh', label: '5 - 7 Lakhs' },
  { value: '7_to_10_lakh', label: '7 - 10 Lakhs' },
  { value: '10_to_15_lakh', label: '10 - 15 Lakhs' },
  { value: '15_to_20_lakh', label: '15 - 20 Lakhs' },
  { value: '20_to_30_lakh', label: '20 - 30 Lakhs' },
  { value: '30_to_50_lakh', label: '30 - 50 Lakhs' },
  { value: '50_lakh_to_1_crore', label: '50 Lakhs - 1 Crore' },
  { value: 'above_1_crore', label: 'Above 1 Crore' },
];
